import { gql } from '@apollo/client';
import type { BoundObjectType } from '@generated/graphql';
/**
 * The household-only slice of the generated `ArchiveEntityBoundModelInput`:
 * every field is required here, and the bound type is fixed until GOAL /
 * SUB_ACCOUNT ship in the UI.
 */
export type ArchiveEntityBoundModelInput = {
  boundObjectType: BoundObjectType.Household;
  boundObjectId: string;
  organizationId: string;
};

/**
 * Retires the household's own copy of a model portfolio, called after the
 * household has been detached from it so that nothing is left pointing at a
 * product no one holds.
 *
 * `archived: false` is the answer for a household that had no live copy, which
 * is a state of affairs rather than a failure. Requires
 * `write:model_portfolios`.
 */
export const ARCHIVE_ENTITY_BOUND_MODEL = gql`
  mutation archiveEntityBoundModel($input: ArchiveEntityBoundModelInput!) {
    archiveEntityBoundModel(input: $input) {
      archived
      modelPortfolio {
        id
        state
      }
    }
  }
`;
